






















import { computed, defineComponent, onBeforeUnmount, onMounted, ref } from "@vue/composition-api";
import { intervalToDuration } from "date-fns";
import { Appointment } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";
import { AppointmentTypeKind } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentTypeProvider";
import { getAppointmentType } from "@/lib/appointmentHelpers";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "JoinAppointmentTooltip",
  components: { BaseButton },
  props: {
    appointment: { type: Object as () => Appointment, required: true },
    isAppointmentStart: { type: Boolean, required: true },
  },
  setup(props) {
    const timer = ref<ReturnType<typeof setTimeout> | null>(null);

    const appointmentType = computed(() => {
      return getAppointmentType(props.appointment);
    });

    const hideJoinBtn = computed(
      () =>
        props.appointment.typeKind === AppointmentTypeKind.TOUR_GUIDE ||
        props.appointment.typeKind === AppointmentTypeKind.MESSAGING
    );

    const getStartTime = () => {
      let result = "";
      if (!props.isAppointmentStart) {
        const { minutes: min = 0, seconds: sec = 0 } = intervalToDuration({
          start: new Date(),
          end: new Date(props.appointment.startTime),
        });
        if (min >= 10 && sec >= 0) {
          result = `${min} min`;
        } else {
          result = `${min}:${sec < 10 ? "0" + sec : sec}`;
        }
      }
      return result;
    };

    const startTime = ref(getStartTime());

    const checkStartTime = () => {
      startTime.value = getStartTime();
      if (props.isAppointmentStart) {
        timer.value && clearTimeout(timer.value);
      } else {
        timer.value = setTimeout(() => {
          checkStartTime();
        }, 1000);
      }
    };

    onMounted(() => {
      checkStartTime();
    });

    onBeforeUnmount(() => {
      timer.value && clearTimeout(timer.value);
    });

    return {
      startTime,
      appointmentType,
      hideJoinBtn,
    };
  },
});
